import React, { useCallback, useEffect, useRef, useState, } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import './data-picker.scss';
import 'swiper/swiper-bundle.css';
import { isValid, parse } from 'date-fns';

interface Props {
    dob: string | null,
    onInit: (val: any) => void
    onChange: (val: number) => void
}

export const YearPicker: React.FC<Props> = ({ dob, onInit, onChange, }) => {
    const emblaRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (!emblaRef) return
        const emblaApi =
            // @ts-ignore
            window.EmblaCarousel(
                emblaRef.current,
                {
                    axis: 'y',
                    dragFree: true,
                    containScroll: false,
                    watchSlides: false,
                    loop: true,
                    forceWheelAxis: 'y',
                },
                [
                    // @ts-ignore
                    new window.EmblaCarouselWheelGestures()
                ]
            )

        
        emblaApi.on('scroll', () => {
            rotateWheel(emblaApi)
        })

        emblaApi.on('reInit', () => {
            inactivateEmblaTransform(emblaApi)
            rotateWheel(emblaApi)
        })

        inactivateEmblaTransform(emblaApi)
        rotateWheel(emblaApi)
    
        if (dob) {
            const date = parse(dob, 'yyyy-MM-dd', new Date())
            if (isValid(date)) {
                emblaApi.scrollTo(
                    new Date()
                        .getFullYear() -
                    18 -
                    date
                        .getFullYear()
                )
            }
        }
        emblaApi.on('pointerUp', () => {
            const { scrollTo, target, location } = emblaApi.internalEngine()
            const diffToTarget = target.get() - location.get()
            const factor = Math.abs(diffToTarget) < WHEEL_ITEM_SIZE / 2.5 ? 10 : 0.1
            const distance = diffToTarget * factor
            scrollTo.distance(distance, true)
            onChange(
                new Date()
                    .getFullYear()
                - 18
                -
                emblaApi
                    .selectedScrollSnap()
            )
        })

        emblaApi.on('scroll', () => {
            rotateWheel(emblaApi)
        })

        emblaApi.on('reInit', () => {
            inactivateEmblaTransform(emblaApi)
            rotateWheel(emblaApi)
        })

        inactivateEmblaTransform(emblaApi)
        rotateWheel(emblaApi)

        if (dob) {
            const date = parse(dob, 'yyyy-MM-dd', new Date())
            if (isValid(date)) {
                emblaApi.scrollTo(
                    new Date()
                        .getFullYear() -
                    18 -
                    date
                        .getFullYear()
                )
            }
        }
        onInit(emblaApi)
    }, [emblaRef])


    const CIRCLE_DEGREES = 360
    const WHEEL_ITEM_SIZE = 28
    const WHEEL_ITEM_COUNT = 18
    const WHEEL_ITEMS_IN_VIEW = 4

    const WHEEL_ITEM_RADIUS = CIRCLE_DEGREES / WHEEL_ITEM_COUNT
    const IN_VIEW_DEGREES = WHEEL_ITEM_RADIUS * WHEEL_ITEMS_IN_VIEW
    const WHEEL_RADIUS = Math.round(
        WHEEL_ITEM_SIZE / 2 / Math.tan(Math.PI / WHEEL_ITEM_COUNT)
    )

    const items =
        Array
            .from({ length: 100 - 18 })
            .map(
                (e, i) =>
                    new Date()
                        .getFullYear()
                        - 18
                        - i
            )
    const totalRadius = items.length * WHEEL_ITEM_RADIUS
    const rotationOffset = 0

    const inactivateEmblaTransform = useCallback(
        (emblaApi: any) => {
            if (!emblaApi) return
            const { translate, slideLooper } = emblaApi.internalEngine()
            translate.clear()
            translate.toggleActive(false)
            slideLooper
                .loopPoints
                // @ts-ignore
                .forEach(({ translate }) => {
                    translate.clear()
                    translate.toggleActive(false)
                })
        },
        []
    )

    const rotateWheel = useCallback(
        (emblaApi: any) => {
            const rotation = items.length * WHEEL_ITEM_RADIUS - rotationOffset
            const wheelRotation = rotation * emblaApi.scrollProgress()
            setContainerStyles(emblaApi, wheelRotation)
            emblaApi
                .slideNodes()
                .forEach((_: any, index: number) => {
                    setSlideStyles(emblaApi, index, true, items.length, totalRadius)
                })
        },
        [rotationOffset, totalRadius]
    )

    const isInView = (wheelLocation: number, slidePosition: number): boolean =>
        Math.abs(wheelLocation - slidePosition) < IN_VIEW_DEGREES

    const setSlideStyles = (
        emblaApi: any,
        index: number,
        loop: boolean,
        slideCount: number,
        totalRadius: number
    ): void => {
        const slideNode = emblaApi.slideNodes()[index]
        const wheelLocation = emblaApi.scrollProgress() * totalRadius
        const positionDefault = emblaApi.scrollSnapList()[index] * totalRadius
        const positionLoopStart = positionDefault + totalRadius
        const positionLoopEnd = positionDefault - totalRadius

        let inView = false
        let angle = index * -WHEEL_ITEM_RADIUS

        if (isInView(wheelLocation, positionDefault)) {
            inView = true
        }

        if (loop && isInView(wheelLocation, positionLoopEnd)) {
            inView = true
            angle = -CIRCLE_DEGREES + (slideCount - index) * WHEEL_ITEM_RADIUS
        }

        if (loop && isInView(wheelLocation, positionLoopStart)) {
            inView = true
            angle = -(totalRadius % CIRCLE_DEGREES) - index * WHEEL_ITEM_RADIUS
        }

        if (inView) {
            slideNode.style.opacity = '1'
            slideNode.style.transform = `translateY(-${
                index * 100
            }%) rotateX(${angle}deg) translateZ(${WHEEL_RADIUS}px)`
        } else {
            slideNode.style.opacity = '0'
            slideNode.style.transform = 'none'
        }
    }

    const setContainerStyles = (
        emblaApi: any,
        wheelRotation: number
    ): void => {
        emblaApi.containerNode().style.transform = `rotateX(${wheelRotation}deg)`
    }


    return (
        <div className="embla__ios-picker">
            <div className="embla__ios-picker__scene">
                <div ref={emblaRef} className="embla__ios-picker__viewport embla__ios-picker__viewport--perspective-center">
                    <div className="embla__ios-picker__container">
                        {
                            items
                                .map((e, index) => (
                                    <div
                                        className="embla__ios-picker__slide"
                                        key={index}>
                                        {`${e}`}
                                    </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};
